export default function (fn, interval) {
  var last = 0

  return function () {
    // this和argument
    var _this = this
    var _arguments = arguments

    var now = new Date().getTime()
    if (now - last > interval) {
      fn.apply(_this, _arguments)
      last = now
    }
  }
}
